import { AlertTriangle } from 'lucide-react';

import { CopyButton } from './CopyButton';

import type { CreateLinkResponse } from '@/types/api';

interface LinkResultProps {
  result: CreateLinkResponse;
  isFirstLink: boolean;
}

export function LinkResult({
  result,
  isFirstLink,
}: LinkResultProps): React.ReactElement {
  return (
    <div className="mt-6 space-y-4 rounded-lg border border-border bg-muted/30 p-4">
      <h3 className="font-semibold">
        {result.existingLink ? '既存のリンク' : '生成結果'}
      </h3>

      {/* Short URL */}
      <div className="space-y-2">
        <label className="text-sm text-muted-foreground">短縮URL</label>
        <div className="flex items-center gap-2">
          <code className="flex-1 rounded bg-background px-3 py-2 text-sm break-all">
            {result.shortUrl}
          </code>
          <CopyButton text={result.shortUrl} />
        </div>
      </div>

      {/* Secret URL - only show for first link or if isFirstLink flag is true */}
      {isFirstLink && (
        <div className="space-y-2 rounded-lg border border-warning bg-warning/10 p-4">
          <div className="flex items-center gap-2 text-warning">
            <AlertTriangle className="h-5 w-5" />
            <span className="font-medium">この秘密URLを保存してください</span>
          </div>
          <p className="text-sm text-muted-foreground">
            一覧ページでリンクを管理するために必要です。このURLを失うと作成したリンクを管理できなくなります。
          </p>
          <div className="flex items-center gap-2">
            <code className="flex-1 rounded bg-background px-3 py-2 text-sm break-all">
              {result.secretUrl}
            </code>
            <CopyButton text={result.secretUrl} />
          </div>
        </div>
      )}

      {/* Link details */}
      <div className="grid grid-cols-3 gap-4 text-sm">
        <div>
          <span className="text-muted-foreground">ステータス:</span>{' '}
          <span className="font-medium">
            {result.status === 'active' ? '有効' : result.status}
          </span>
        </div>
        <div>
          <span className="text-muted-foreground">有効期限:</span>{' '}
          <span className="font-medium">
            {result.expiresAt
              ? new Date(result.expiresAt).toLocaleDateString('ja-JP')
              : '無期限'}
          </span>
        </div>
        <div>
          <span className="text-muted-foreground">クリック数:</span>{' '}
          <span className="font-medium">{result.clickCount}</span>
        </div>
      </div>
    </div>
  );
}
